import axios from 'axios';
import { authorizedAxios } from './axiosInstances';

const API_URL = `${process.env.VUE_APP_API_BASE_URL}/api/Feature/auth`;

class AuthService {
  login(credential) {
    return axios
      .post(`${API_URL}/signin`, {
        userName: credential.userName,
        password: credential.password,
      })
      .then((response) => {
        if (!response.data.accessToken) {
          this.logout();
        }

        return response.data;
      });
  }

  getUserProfileList() {
    return authorizedAxios
      .get(`${API_URL}/userProfileList?isIntranetUser=true`)
      .then((response) => {
        return response.data;
      });
  }

  getUserProfileListWithCredential(credential) {
    return axios
      .post(`${API_URL}/userProfileList/credential?isIntranetUser=true`, credential)
      .then((response) => {
        return response.data;
      });
  }

  sendPasswordRecoveryLink(userName) {
    return axios
      .get(`${API_URL}/send/recoveryLink?userName=${encodeURIComponent(userName)}&appType=${2}`)
      .then((response) => {
        return response.data;
      });
  }

  verifyResetPasswordLink(userId, verificationId) {
    return axios
      .post(`${API_URL}/verify/resetPasswordLink`, {
        userId: parseInt(userId),
        verificationId: verificationId,
      })
      .then((response) => {
        return response.data;
      });
  }

  resetPassword(userId, verificationId, password) {
    return axios
      .post(`${API_URL}/reset/password`, {
        userId: parseInt(userId),
        verificationId: verificationId,
        password: password,
      })
      .then((response) => {
        return response.data;
      });
  }

  switchUserProfile(userProfile) {
    return authorizedAxios.post(`${API_URL}/switchUserProfile`, userProfile).then((response) => {
      return response.data;
    });
  }

  getNavMenuList() {
    return authorizedAxios.get(`${API_URL}/intranet/menuList`).then((response) => {
      return response.data;
    });
  }

  //   register(user) {
  //     return axios.post(API_URL + 'signup', {
  //       username: user.username,
  //       email: user.email,
  //       password: user.password
  //     });
  //   }
}

export default new AuthService();
